// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"127":"9bde15ae","261":"7fcd85d6","364":"32f797ae","824":"9b5215d1","945":"8391184f","992":"92dcd40b"}[chunkId] + ".js";
};